import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { NEW_ORDERS_URL, OPEN_ORDERS_URL, ORDERS_HISTORY_URL } from "../../const/URL.const";
import { IReduxAppState } from "../../reducers";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import { ICollectionPoint } from "../ordersSetting/Forms/CollectionPointEntity";
import { ISidebarItem, MenuContainerTabs } from "../Routes";
import { OrderParentContainer } from "./OrderParentContainer";
import { OrdersContainer } from "./OrdersContainer";

export interface IOrderRouteChildren {
    tab: ISidebarItem;
    collectionPoints: ICollectionPoint[];
}

export function OrderRouter() {
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { apiData: collectionPoints } = useAPIV2<any>(APIExtensions.collectionPoints, { yoelloAPIParams: { venue_id: selectedVenueId, include_disabled: true, include_deleted: true } });

    return <Switch>
        <Route path={ORDERS_HISTORY_URL}>
            <OrdersContainer tab={MenuContainerTabs.ORDER_HISTORY} collectionPoints={collectionPoints} />
        </Route>
        <Route path={OPEN_ORDERS_URL}>
            <OrderParentContainer orderKey="openedOrders" tab={MenuContainerTabs.OPEN_ORDERS} collectionPoints={collectionPoints} />
        </Route>
        <Route path={NEW_ORDERS_URL}>
            <OrderParentContainer orderKey="newOrders" tab={MenuContainerTabs.NEW_ORDERS} collectionPoints={collectionPoints} />
        </Route>

    </Switch>
}